import { ModuleSidebar } from "@/components/modules/ModuleSidebar";
import { MODULES } from "@/lib/modules/registry";

export function VestibularesSidebar() {
  return <ModuleSidebar config={MODULES.vestibulares} />;
}
